import { NgModule, forwardRef, APP_INITIALIZER } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UserModule } from './modules/user/user.module';
import { GroupModule } from './modules/group/group.module';
import { SharedModule } from 'shared/shared.module';
import { MatComponentsModule } from './modules/mat-components/mat-components.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppComponent } from './app.component';
import { MdTabNavigationComponent } from './modules//md-tab-navigation/md-tab-navigation.component';
import { AuthGuard } from './shared/services/Guards/Auth-Guard/auth-guard.service';
import { SsAuthService } from './shared/services/SS-Auth/ss-auth.service';
import { AuthService } from './shared/services/Auth/auth.service';
import { UserService } from './shared/services/User/user.service';
import { FacebookModule } from 'ngx-facebook';
import { FacebookService } from 'ngx-facebook';
import { SsInventoryService } from 'shared/services/SS-Inventory/ss-inventory.service';
import { PaymentService } from 'shared/services/Payment/payment.service';
import { GroupsGuard } from 'shared/services/Guards/groups-guard';
import { GroupListComponent } from './modules/group/components/group-list/group-list.component';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { VendorsService } from 'shared/services/SS-vendors/vendors.service';
import { ZendeskWebwidgetModule, ZendeskWebwidgetConfig } from 'ng-zendesk-webwidget';
import { SsOnboardingService } from 'shared/services/SS-Onboard/ss-onboarding.service';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { environment } from 'environments/environment';
import { UIService } from 'shared/services/UI/ui.service';
import { EmailVerificationDialogComponent } from 'shared/services/User/AuthDialog/email-verification/email-verification.component';
import { TurnDialogComponent } from 'app/modules/draft/dialogs/turn-dialog-container/turn-dialog-container.component';
import { DraftModule } from './modules/draft/draft.module';
import { OnboardingGuard } from 'shared/services/Guards/Onboarding/onboarding-guard.component';
import { DraftService } from './modules/draft/services/draft.service';
import { GoogleAnalyticsService } from 'shared/services/analytics.service';
import { ReservationsModule } from './modules/reservations/reservations.module';
import { ReservationService } from 'shared/services/Reservations/reservations.service';

export class ZendeskConfig extends ZendeskWebwidgetConfig {
  accountUrl = environment.ZENDESK_DOMAIN;
  beforePageLoad(zE) {
    zE.setLocale('en');
    zE.hide();
  }
}

@NgModule({
  declarations: [
    AppComponent,
    MdTabNavigationComponent,
    TurnDialogComponent,
    EmailVerificationDialogComponent,
  ],
  imports: [
    SharedModule,
    MatComponentsModule,
    FlexLayoutModule,
    UserModule,
    GroupModule,
    DraftModule,
    ReservationsModule,
    ReactiveFormsModule,
    ZendeskWebwidgetModule.forRoot(ZendeskConfig),
    RouterModule.forRoot([
      {
        path: '',
        component: MdTabNavigationComponent,
        children: [
          { path: '', component: GroupListComponent, canActivate: [AuthGuard] },
        ]
      }
    ]),
    FacebookModule.forRoot(),
  ],
  providers: [
    AuthService,
    AuthGuard,
    GroupsGuard,
    FacebookService,
    SsAuthService,
    UserService,
    SsInventoryService,
    PaymentService,
    DataSharingService,
    VendorsService,
    SsOnboardingService,
    AlertPopupService,
    UIService,
    OnboardingGuard,
    DraftService,
    GoogleAnalyticsService,
    ReservationService
  ],
  entryComponents: [
    TurnDialogComponent,
    EmailVerificationDialogComponent
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts